"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "onChange", "strict", "uppercase"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/InputText/index.js";
var noop = function noop() {};
var defaultProps = {
  type: 'text',
  onChange: noop
};
function InputText(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    strict = _ref.strict,
    uppercase = _ref.uppercase,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value;
    var character = value.charAt(value.length - 1);
    // only string
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }
    if (uppercase) {
      e.target.value = value.toUpperCase();
    }
    onChange(e.target.value);
  }
  return /*#__PURE__*/_react["default"].createElement("textarea", Object.assign({
    className: (0, _classNames["default"])('form-control', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }));
}
InputText.defaultProps = defaultProps;
var _default = exports["default"] = InputText;